import styled from 'styled-components';
import { px2rem } from '../../../../stylesheets/tools';

const StyledEducationContentType = styled.section`
  display: flex;
  align-items: center;
  gap: ${px2rem('6px')};

  .contentType__title {
    text-transform: uppercase;
    font-size: ${px2rem('18px')};
  }
`;

export default StyledEducationContentType;
